import { render, staticRenderFns } from "./IdentificationChecked.vue?vue&type=template&id=4ac4d346&scoped=true"
import script from "./IdentificationChecked.vue?vue&type=script&lang=js"
export * from "./IdentificationChecked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac4d346",
  null
  
)

export default component.exports